import React, {CSSProperties, ReactNode} from "react";
import {IconButton, Stack} from "@mui/material";
import {Add, DragHandle, Remove} from "@mui/icons-material";
import {DragAndDrop} from "../DragAndDrop";

export interface ListFieldItemProps<E> {
	readonly value: E;
	readonly setValue: (value: E) => void;
	readonly disabled?: boolean;
}

export interface ListFieldProps<E> {
	readonly value: E[];
	readonly setValue: (value: E[]) => void;
	readonly newValue: () => E;
	readonly render: (props: ListFieldItemProps<E>) => ReactNode;
	readonly disabled?: boolean;
	
	readonly label?: string;
	readonly disableDragging?: boolean;
	readonly disableAdding?: boolean;
	readonly disableRemoving?: boolean;
	
	readonly style?: CSSProperties;
}

export function ListField<E>(props: ListFieldProps<E>) {
	function content(value: E, index: number) {
		function setValue(newValue: E) {
			const newList = [...props.value];
			newList[index] = newValue;
			props.setValue(newList);
		}
		
		return <Stack direction={"row"} alignItems={"start"}>
			{!props.disableRemoving && <IconButton
				color={"primary"}
				disabled={props.disabled}
				onClick={() => {
					const newValue = [...props.value];
					newValue.splice(index, 1);
					props.setValue(newValue);
				}}
			>
				<Remove/>
			</IconButton>}
			{props.render({value, setValue, disabled: props.disabled})}
			{!props.disableDragging && <DragHandle/>}
		</Stack>;
	}
	
	return <Stack spacing={1} style={props.style}>
		{props.label && <div>{props.label}</div>}
		{props.disableDragging
			? props.value.map(content)
			: <DragAndDrop items={props.value} disabled={props.disabled} onItemsChanged={props.setValue}>{content}</DragAndDrop>}
		{!props.disableAdding &&
			<div>
				<IconButton
					color={"primary"}
					disabled={props.disabled}
					onClick={() => props.setValue([...props.value, props.newValue()])}
				>
					<Add/>
				</IconButton>
			</div>}
	</Stack>;
}
